import { computed, type ComputedRef } from 'vue';
import useMasterKillSwitch from '@/composables/useMasterKillSwitch';
import { usePageDataStore } from '@/stores/pageDataStore';
import checkingRouteForSysPage from '~/features/shop-your-store/composables/checkRouteForSysPage';

const experimentIdArm1 = '3158-21';
const experimentIdArm2 = '3158-22';

export default function useGetItToday(): { isGetItTodayEnabled: ComputedRef<boolean> } {
  const isGitTreatmentActive = useMasterKillSwitch('getItTodayEnabled', [experimentIdArm1, experimentIdArm2]);
  const isSYS = !!checkingRouteForSysPage();
  const pageDataStore = usePageDataStore();
  const isEnabledOnPageLevel = computed(() => !pageDataStore.getDisableDeliveryAndFulfillmentFacet && pageDataStore.getIsDomestic);

  const isGetItTodayEnabled = computed(() => {
    return isGitTreatmentActive.value && isEnabledOnPageLevel.value && !isSYS;
  });

  return {
    isGetItTodayEnabled,
  };
}
